export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./create.vue?vue&type=template&id=2e47f085&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/players/player/create.vue?vue&type=template&id=2e47f085&scoped=true
// module id = xXYm
// module chunks = 0